import { Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class IntegracaoMonitoramentoKeys extends MainKeys {
    get place() {
        return Places.mcIntegracaoMonitoramento
    }
}

export default IntegracaoMonitoramentoKeys
